export function shouldSubmitChat(event, mobile = false, composing = false) {
    return event.key === 'Enter' && !event.shiftKey && !event.altKey && !event.repeat
        && !composing && !event.nativeEvent?.isComposing && event.nativeEvent?.keyCode !== 229
        && (!mobile || event.ctrlKey || event.metaKey);
}
export function chatDayKey(value) {
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}` : '';
}
export function chatDayLabel(value, now = new Date()) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return 'Unknown date';
    if (chatDayKey(value) === chatDayKey(now.toISOString())) return 'Today';
    const yesterday = new Date(now); yesterday.setDate(yesterday.getDate() - 1);
    if (chatDayKey(value) === chatDayKey(yesterday.toISOString())) return 'Yesterday';
    return date.toLocaleDateString(undefined, {day: 'numeric', month: 'short', year: date.getFullYear() === now.getFullYear() ? undefined : 'numeric'});
}
export function groupChatMessages(message, previous) {
    if (!previous || !message.sender || !previous.sender || message.deleted_at || previous.deleted_at || message.pending || previous.pending || message.send_error || previous.send_error) return false;
    if (message.message_type === 'SYSTEM' || previous.message_type === 'SYSTEM') return false;
    if ((message.thread_root_message_id || 0) !== (previous.thread_root_message_id || 0)) return false;
    if ((!message.thread_root_message_id && message.reply_count > 0) || (!previous.thread_root_message_id && previous.reply_count > 0)) return false;
    const gap = Date.parse(message.created_at) - Date.parse(previous.created_at);
    return message.conversation_id === previous.conversation_id && message.sender.id === previous.sender.id
        && chatDayKey(message.created_at) === chatDayKey(previous.created_at) && gap >= 0 && gap < 300000;
}
